import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Initialize the controller
  }



  showModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Handle form submission
  submitForm(event) {
    // Let the form submit normally, but close modal on success
    // The form will redirect on success, so we don't need to handle it here
    // If there are validation errors, they'll be shown in the response
  }
} 